// extracted by mini-css-extract-plugin
module.exports = {"banner":"BzTZxR","countdown":"_2-J5gB","bg":"_2UG6d5"};